import React from "react";
import { Sanitizer } from "@base/reactUtil/Sanitizer";
import { getValueOrCallback, ValueOrCallback } from "@base/util/TypeUtil";

export const Html = (props: { html: string; className?: string; tag?: "div" | "span", sanitizer?: "svg" | "html" }) => {
  const { html, className, sanitizer, tag = "div" } = props;

  const CustomTag = tag;

  if (!html?.length) return null;
  const purified = Sanitizer.sanitize(html, sanitizer);
  const obj = { __html: purified };
  return <CustomTag className={className || ""} dangerouslySetInnerHTML={obj} />
};

export const HtmlSpan = (props: { html: string; className?: string }) => {
  if (!props.html?.length) return null;
  const obj = { __html: Sanitizer.html(props.html) };
  if (props.className) return <span className={props.className} dangerouslySetInnerHTML={obj}></span>;
  else return <span dangerouslySetInnerHTML={obj}></span>;
};


interface SwitchProps<T> {
  value: T;
  defaultComponent?: React.ReactNode;
  children?: React.ReactNode;
}

export const Switch = <T,>(props: SwitchProps<T>) => {
  const { value, children, defaultComponent } = props;
  const childs = React.Children.toArray(children);
  const item = childs.filter((c) => (c as any).props.value === value)
  if (item)
    return <>{item}</>;
  if (defaultComponent)
    return defaultComponent;
  return <></>
}

export const Case = <T,>(props: {
  value: T,
  children?: React.ReactNode
}) => {
  return <>{props.children}</>
}

export const RenderIf = (props: {
  children?: React.ReactNode
  condition: ValueOrCallback<boolean>;
}) => {
  const { children, condition } = props;
  const conditionValue = getValueOrCallback(condition);
  if (!conditionValue)
    return null;

  return children;
}